import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { elevatedSlotIndex } from 'src/app/core/helpers/ui/quick-access-layout';
import { QUICK_ACCESS_COMPACT_BAR_MAX_ITEMS } from 'src/app/core/helpers/ui/quick-access.constant';
import { QuickAccessPage } from 'src/app/core/interfaces/ui/quick-access.interface';

@Component({
  selector: 'shared-bottom-nav-bar',
  templateUrl: './bottom-nav-bar.component.html',
  styleUrls: ['./bottom-nav-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BottomNavBarComponent {
  @Input() showHint: boolean = false;
  @Input() suppressNavigation: boolean = false;
  @Input() slots: (QuickAccessPage | null)[] = [];

  @Output() longPress = new EventEmitter<void>();
  @Output() dismissHint = new EventEmitter<void>();
  @Output() actionClick = new EventEmitter<QuickAccessPage>();

  private get elevatedIndex(): number | null {
    return elevatedSlotIndex(this.slots);
  }

  get middleSlot(): QuickAccessPage | null {
    const index = this.elevatedIndex;
    return index === null ? null : (this.slots[index] ?? null);
  }

  get leadingSlots(): QuickAccessPage[] {
    const index = this.elevatedIndex;
    const end = index === null ? this.slots.length : index;
    return this.slots.slice(0, end).filter((slot): slot is QuickAccessPage => !!slot);
  }

  get trailingSlots(): QuickAccessPage[] {
    const index = this.elevatedIndex;
    if (index === null) return [];
    return this.slots.slice(index + 1).filter((slot): slot is QuickAccessPage => !!slot);
  }

  get hasAnySlot(): boolean {
    return this.slots.some((slot) => !!slot);
  }

  private get filledCount(): number {
    return this.slots.filter((slot) => !!slot).length;
  }

  get isCompactBar(): boolean {
    return this.filledCount > 0 && this.filledCount <= QUICK_ACCESS_COMPACT_BAR_MAX_ITEMS;
  }
}
